import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Typography
} from '@mui/material';

import SummaryCard from './SummaryCard';

const DiagnosisSummary = ({
  diagnoses,
  onEdit,
  showEdit
}) => {
  if (!diagnoses?.length) {
    return null;
  }

  return (
    <SummaryCard
      title="Diagnosis"
      onEdit={onEdit}
      showEdit={showEdit}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5
        }}
      >
        {diagnoses.map((diagnosis, index) => (
          <Typography
            key={`${diagnosis.code}-${index}`}
            sx={{
              color: '#424242',
              fontSize: 13,
              lineHeight: 1.8
            }}
          >
            {diagnosis.code} {diagnosis.description}
          </Typography>
        ))}
      </Box>
    </SummaryCard>
  );
};

DiagnosisSummary.propTypes = {
  diagnoses: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string
    })
  ),
  onEdit: PropTypes.func,
  showEdit: PropTypes.bool
};

DiagnosisSummary.defaultProps = {
  diagnoses: [],
  onEdit: () => {},
  showEdit: true
};

export default DiagnosisSummary;